import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { AppConfigService } from 'src/app/app-config.service';
import { EndpointBuilderService } from 'src/app/shared/services/endpint-builder.service';
import { ApiEnum } from 'src/app/shared/enum/api.enum';
import { CommonService } from '../../common-service';
import { ListReportTypeResponse } from '../../responses/report/list-report-type.response';

@Injectable({
  providedIn: 'root'
})
export class ReportTypeService extends CommonService{

  constructor(private router: Router, private httpClient: HttpClient, configService: AppConfigService, private endpointBuilder: EndpointBuilderService) {
    super(configService);
  }

  listReportTypeWithTemplate(): Observable<ListReportTypeResponse>{
    let uri = `ReportType`
      
    return this.httpClient.get<ListReportTypeResponse>(this.endpointBuilder.getEndpoint(ApiEnum.urlApiReport) + uri,this.addHeaderToken())
    .pipe(
      catchError(this.handleError)
    )
  }
}
